import { GenericWithUserId } from "../../model/shared/dto/GenericWithUserId";
import { UpdateUserSettingsDto } from "../../model/user/settings/dto/UpdateUserSettingsDto";
import { UserSettings } from "../../model/user/settings/types/UserSettings";
import { AtiraApi } from "../AxiosClient";

export class SettingsAxios {
  static updateSettings(dto: UpdateUserSettingsDto) {
    return AtiraApi.patch(`/user/${dto.userId}/settings`, dto).then(
      ({ data }) => data,
    );
  }

  static getSettings(dto: GenericWithUserId) {
    return AtiraApi.post<UserSettings>(
      `/user/${dto.userId}/settings`,
      dto,
    ).then(({ data }) => data);
  }
}
